<template>
	<div>
		<!-- =========== End of Loader ============ -->

		<main class="main hidden">
			<!-- =========== Start of Navigation (main menu) ============ -->
			<header class="navbar navbar-expand-lg navbar-dark">
				<div class="container position-relative">
					<router-link to="/" class="navbar-brand">
						<img
							class="navbar-brand__regular"
							src="/assets/logo.png"
							alt="brand-logo"
							width="80px"
							height="80px"
						/>
					</router-link>
					<!--  End of brand logo -->
				</div>
				<!-- end of container -->
			</header>
			<!-- =========== End of Navigation (main menu)  ============ -->

			<!-- =========== Start of Body ============ -->
			<section
				class="space bg-color--dark--1 h-min-100vh d-flex align-items-center"
			>
				<div class="svg-shape--top w-100 opacity--05">
					<img
						src="/assets/img/wave-8.svg"
						alt="wave"
						class="svg fill--white"
					/>
				</div>
				<!-- end of whole area svg bg -->
				<div class="svg-shape--top opacity--10">
					<img src="assets/img/wave-9.svg" alt="wave" class="svg fill--white" />
				</div>
				<!-- end of top right mini svg shape -->

				<div class="container">
					<div class="row">
						<div class="col-12 mx-auto color--white text-center mb-2 mb-lg-2">
							<h1 class="h2-font mb-1 text-white">{{ $t("login.signUp") }}</h1>
						</div>
						<div class="col-12 col-sm-10 col-md-8 col-lg-7 col-xl-6 mx-auto">
							<div
								class="form--v5 bg-color--light--1 px-3 py-4 px-md-5 py-md-6 rounded--10"
							>
								<form class="form needs-validation" novalidate>
									<div
										class="alert alert-danger"
										role="alert"
										id="alert"
										v-show="alert"
									>
										<ul>
											<li v-for="err in errors" :key="err">
												{{ err }}
											</li>
										</ul>
									</div>
									<div class="form-group">
										<label
											class="form__label text-uppercase font-size--15 font-w--500"
											>{{ $t("login.phoneNumber") }}</label
										>
										<input
											id=" mobile_number"
											type="number"
											v-model.trim="$v.mobile_number.$model"
											class="form-control form__label"
											:class="{ 'is-invalid': $v.mobile_number.$error }"
											@blur="$v.mobile_number.$touch()"
											placeholder="لطفا شماره همراه خود را وارد کنید"
											@wheel="$event.target.blur()"
										/>
										<div
										class="invalid-feedback"
										v-if="!$v.mobile_number.required"
									>
										ورود شماره همراه لازم است
									</div>
									<div
										class="invalid-feedback"
										v-if="
											!$v.mobile_number.minLength || !$v.mobile_number.maxLength
										"
									>
										شماره تلفن نامعتبر است
									</div>
									</div>
									
									<div class="row align-items-center justify-content-around">
										<button
											class="col-md-12 btn btn-bg--primary btn-size--md btn-hover--3d"
											@click.prevent="getOtp"
										>
											<span class="btn__text">{{ $t("login.getcode") }}</span>
										</button>
										<br />
										<br />
										<div>
											<p
												class="col-md-12 text-color--400 font-size--15 mt-2 mt-sm-0"
											>
												{{ $t("login.haveAccount") }}
												<router-link
													to="login"
													href="login.html"
													class="color--primary"
													>{{ $t("login.login") }}</router-link
												>
											</p>
										</div>
									</div>
								</form>
								<!-- end of form -->
							</div>
							<!-- end of from area -->
						</div>
						<!-- end of col -->
					</div>
					<!-- end of row -->
				</div>
				<!-- end of container -->
			</section>
			<!-- =========== End of Body ============ -->
		</main>
	</div>
</template>

<script>
	// @ is an alias to /src

	//import router from '../../router'
	import { required, minLength, maxLength } from "vuelidate/lib/validators";
	export default {
		data() {
			return {
				mobile_number: "",
				alert: false,
				errors: [],
				submitStatus:""
			};
		},
		methods: {
			getOtp() {
				const mobile_number = this.mobile_number;
				this.$v.$touch();
				if (this.$v.$invalid) {
					this.submitStatus = "ERROR";
				} else {
					this.$store
						.dispatch("getOtp", { mobile_number })
						.then(() => this.$router.push("/otp-code"))
						.catch(err => {
							console.log("err: ", err);
							this.alert = true;
							this.errors = err.body;
						});
				}
			}
		},
		validations: {
			mobile_number: {
				required,
				minLength: minLength(11),
				maxLength: maxLength(11)
			}
		}
	};
</script>
